export class MobileFeedDto {
    isSurroundingsVerified?: boolean;
    isMobileNetworkAvailable?: Boolean;
    isAssessmentSubmitted?: boolean;
    mobileFeedCaptured?: boolean = false;
    isMobileSetUpDone?: boolean;
}
